const EventHub = (function() {

    var data,
        trigger,
        insertCallback,
        removeCallback,
        on,
        off;

    data = {
        triggers : [],
        callbacks : {}
    };

    trigger = function(eventName) {
        // @desc    Triggers an event and invokes callbacks with optional arguments.
        //          To pass several strings (e.g.) to the callback, use trigger function like this:
        //          EventHub.trigger('myEvent','myStringIWantToUseInMyCallback','another String');
        //          The strings are available within the callback as array like this:
        //          EventHub.on('myEvent', function(argumentsArray) {
        //              console.log('this is myStringIWantToUseInMyCallback: ' + argumentsArray[0]);
        //              console.log('this is another String: ' + argumentsArray[1]);
        //          });
        // @param   {string} eventName

        var i,
            callbacks,
            callbacksLength,
            args = Array.prototype.slice.call(arguments, 1);

        if (data.callbacks[eventName]) {
            callbacks = data.callbacks[eventName].slice();
            callbacksLength = callbacks.length;

            for (i = 0; i < callbacksLength; i += 1) {
                callbacks[i](args);
            }
        }
    };

    on = function(eventName, callback) {
        // @desc    Start to listen for a specific event on the eventhub
        // @param   {string} eventName
        // @param   {function} callback function, which gets fired,
        //          as soon as the event was triggered

        if (eventName && typeof eventName === 'string') {
            data.triggers.push(eventName);
            if (typeof callback === 'function') {
                insertCallback(eventName, callback);
            }
        }
    };

    off = function(eventName, callback) {
        // @desc    Removes an event and its associated callbacks
        // @param   {string} eventName

        var i,
            triggersLength = data.triggers.length;

        if (eventName && typeof eventName === 'string') {
            if (typeof callback === 'function' && data.callbacks[eventName]) {
                data.callbacks[eventName] = data.callbacks[eventName].filter(function(registeredCallback) {
                    return registeredCallback !== callback;
                });

                if (data.callbacks[eventName].length === 0) {
                    removeCallback(eventName);
                }

                return;
            }

            // Remove eventName from triggers array
            for (i = 0; i < triggersLength; i += 1) {
                if (data.triggers[i] === eventName) {
                    data.triggers.splice(i, 1);
                }
            }
            // Remove callbacks
            removeCallback(eventName);
        }
    };

    insertCallback = function(eventName, callback) {
        if (!data.callbacks[eventName]) { // Already registered callbacks for this event
            data.callbacks[eventName] = [];
        }
        data.callbacks[eventName].push(callback);
    };

    removeCallback = function(eventName) {
        delete data.callbacks[eventName];
    };

    return {
        trigger : trigger,
        on : on,
        off : off
    };

}());

export default EventHub;
